import {AlpineComponent} from 'alpinejs';

type LanguageSuggestionData = {
  open: boolean;
  dismiss: () => void;
}

const COOKIE_NAME = 'sitepackage_language_suggestion_dismissed';

export default (): AlpineComponent<LanguageSuggestionData> => ({
  open: !document.cookie.includes(`${COOKIE_NAME}=1`),
  dismiss() {
    document.cookie = `${COOKIE_NAME}=1; path=/`;
    this.open = false;
  }
});